import { v4 as uuidv4 } from 'uuid';

export function generateDocumentId(): string {
  return uuidv4().substring(0, 6);
}
